import { GridReadyEvent } from "@ag-grid-community/core";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { ActivatedRoute } from "@angular/router";
import { AgFns, GridOptionsExt } from "app/shared/ag-fns";
import { DialogBaseComponent } from "app/shared/dialog-base.component";
import { takeUntil } from "rxjs/operators";
import { AddonStation } from "../model/entities/entity-model";
import { DomainBaseComponent, wrapBusy } from "../shared/domain-base.component";
import { DomainService } from "../shared/domain.service";
import { AddonStationDialogParams, EditGenericEntityDialogComponent } from "../shared/edit-generic-entity-dialog.component";
import { UniAgFns } from "@/shared/uni-ag-fns";

@Component({
  selector: "app-addon-station",
  templateUrl: "./addon-station.component.html",

  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AddonStationComponent extends DomainBaseComponent implements OnInit {
  aosGridOptions: GridOptionsExt;
  selectedAddonStation: AddonStation;
  addonStations: AddonStation[];
  DialogBaseComponent: any;

  constructor(protected domainService: DomainService, protected route: ActivatedRoute) {
    super(domainService);

    this.route.queryParamMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  async updateFromContext() {
    this.aosGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onAosGridReady,
      onRowSelected: AgFns.handleRowSelected((e: AddonStation) => (this.selectedAddonStation = e)),
    });
    AgFns.captureGridRouteParams(this.aosGridOptions, this.route, "id");

    this.addonStations = await this.dbQueryService.getAll(AddonStation);

    this.isPageReady = true;
  }

  async canDeactivate() {
    const ok = await super.canDeactivate();
    if (!ok) return false;
    this.uow.clearEntities(AddonStation);
    return true;
  }

  onAosGridReady(event: GridReadyEvent) {
    const colDefs = [
      this.productAdminAllow({
        ...AgFns.createButtonProps("", this.addonStationEdit.bind(this), {
          label: "Edit",
        }),
        maxWidth: 60,
        minWidth: 60,
      }),
      { headerName: "Name", field: "name", filter: "agTextColumnFilter" },
      { ...UniAgFns.getActiveStatusColDef("activeStatus.name") },
      UniAgFns.getEntityDeleteColDef(this.onDelete.bind(this), {
        canDisplay: () => true,
      }),
      // { headerName: "Id", field: "id", filter: "agNumberColumnFilter" },
    ];
    // sorted on server.
    AgFns.initGrid(event, colDefs, null);
  }

  productAdminAllow(x: any) {
    return this.user.isProductAdmin ? x : {};
  }

  updateLocation(key: any = null) {
    const urlTree = this.router.createUrlTree(["/addon-stations"]);
    const url = AgFns.buildGridRouteParamsUrl(urlTree, this.aosGridOptions, key && key.toString());
    this.domainService.location.replaceState(url);
  }

  // -----------------------------------------------------

  @wrapBusy
  async onDelete(aos: AddonStation) {
    const _aos = await this.dbQueryService.getAddOnStation(aos.id);
    if (_aos.addons.length > 0) {
      await this.dialogService.okDialog("Cannot Delete", "Cannot delete Add-On Station that has applied Add-Ons.");
      return;
    }
    const ok = await this.dialogService.yesNoDialog("Delete this Add-On Station?", "Are you sure?");
    if (!ok) return;

    _aos.entityAspect.setDeleted();
    const sr = await this.dbSaveService.saveChanges();
    if (sr.httpResponse.statusText == "OK") {
      this.toastr.success("Manufacturer Product Type Configuration successfully deleted");
      this.addonStations = await this.dbQueryService.getAll(AddonStation);
      AgFns.refreshGrid(this.aosGridOptions, this.addonStations);
    } else {
      this.toastr.error("Add-On Station delete failed", "Unable to Delete");
    }
  }

  async addonStationEdit(addonStation?: AddonStation) {
    const r = await DialogBaseComponent.open(EditGenericEntityDialogComponent, this, {
      ...AddonStationDialogParams,
      target: addonStation,
    });
    if (r) {
      if (addonStation == null) {
        this.addonStations = await this.dbQueryService.getAll(AddonStation);
      }
      AgFns.refreshGrid(this.aosGridOptions, this.addonStations);
    }
  }
}
